var map = {
	"./de_DE.json": [
		4853,
		96
	],
	"./en_US.json": [
		6358,
		96
	],
	"./es_ES.json": [
		3639,
		96
	],
	"./fr_FR.json": [
		7659,
		96
	],
	"./it_IT.json": [
		7225,
		96
	],
	"./ja_JP.json": [
		3026,
		96
	],
	"./ko_KR.json": [
		4652,
		96
	],
	"./pt_BR.json": [
		6611,
		96
	],
	"./zh_CN.json": [
		3948,
		96
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5079;
module.exports = webpackAsyncContext;